import { Course } from './../builders/course_builder';
import { College } from './../builders/college_builder';
import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-transfer')
  .factory('loadTransferStudentCommand', (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    loadTransferSelectedMajorsCommand: ICommand,
    loadTransferSelectedCoursesCommand: ICommand,
    loadTransferPendingCoursesCommand: ICommand,
    loadTransferSelectedCollegesCommand: ICommand,
    loadTransferProgressStateCommand: ICommand,
    loadTransferSelectedExamsCommand: ICommand,
    $http: ng.IHttpService,
    $q: ng.IQService
  ): ICommand => {
    return defineCommand('loadTransferStudentCommand', (deferred: ng.IDeferred<IQuery[]>): void => {

      $http({
        method: 'GET',
        url: `student/`
      })
      .then((response: ng.IHttpPromiseCallbackArg<any>): void => {

        $q.all([
          loadTransferSelectedMajorsCommand(response),
          loadTransferSelectedCoursesCommand(response),
          loadTransferPendingCoursesCommand(response),
          loadTransferSelectedCollegesCommand(response),
          loadTransferProgressStateCommand(response),
          loadTransferSelectedExamsCommand(response)
        ]).then((queries) => {
          deferred.resolve(_.flatten(queries));
        });

      })
      .catch(deferred.reject);

    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_student_command.ts